const TooltipTable = ({ children }) => {
  return (
    <div className="d-flex flex-direction-column tooltip-table overflow-hidden">
      <div className="flex-1 custom-scroll-bar">
        <table>{children}</table>
      </div>
    </div>
  );
};

export default TooltipTable;
